import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Audit } from '../audits/audit.model';

@Injectable()
export class AuditService {
    private recentChanges: Audit[] = [];

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl, private adalService: AdalService) {
    }

    getUserChanges(userId: string): Promise<Audit[]> {
        var url = this.baseApiUrl + 'v1/changes/' + userId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var audits = resp.json().body as Audit[];
                return audits;
            })
            .catch(this.handleError);
    }

    getRecentChanges(): Promise<Audit[]> {
        var url = this.baseApiUrl + 'v1/changes';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                this.recentChanges = resp.json().body as Audit[];
                return this.recentChanges;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/audits/audit.service.ts